import { Typography } from "@monolith-forensics/monolith-ui";
import styled from "styled-components";

import { usePermissions } from "../../hooks/usePermissions";
import { Helmet } from "react-helmet-async";

import AccessDeniedMessage from "../../components/AccessDeniedMessage.js";

import { Case } from "../Cases/types/Cases.js";

import ContactsTable from "../../Features/Contacts/Tables/ContactsTable";

const CaseContactsSectionContent = styled(
  ({ className, stateStoreKey = "contacts:view", caseInfo }) => {
    return (
      <div className={className}>
        {!caseInfo && (
          <>
            <Helmet title="Contacts" />
            <Typography variant="h3" gutterBottom display="inline">
              Contacts
            </Typography>
          </>
        )}
        <ContactsTable stateStoreKey={stateStoreKey} />
      </div>
    );
  }
)`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const CaseContacts = (props: {
  className?: string;
  stateStoreKey?: string;
  defaultQueryKey?: string;
  caseInfo?: Case;
}) => {
  const { hasPermission, MONOLITH_PERMISSIONS } = usePermissions();

  if (!hasPermission(MONOLITH_PERMISSIONS.CONTACTS_READ_ALL)) {
    return <AccessDeniedMessage />;
  }

  return <CaseContactsSectionContent {...props} />;
};

export default CaseContacts;
